var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHearing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hearing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5 30.585C25.065 30.585 24.66 30.495 24.36 30.36C23.295 29.805 22.545 29.04 21.795 26.79C21.03 24.45 19.59 23.355 18.21 22.29C17.025 21.375 15.795 20.43 14.73 18.495C13.935 17.055 13.5 15.48 13.5 14.085C13.5 9.88504 16.8 6.58504 21 6.58504C25.2 6.58504 28.5 9.88504 28.5 14.085H31.5C31.5 8.19004 26.895 3.58504 21 3.58504C15.105 3.58504 10.5 8.19004 10.5 14.085C10.5 15.975 11.07 18.06 12.105 19.935C13.47 22.41 15.075 23.655 16.38 24.66C17.595 25.59 18.465 26.265 18.945 27.735C19.845 30.465 21 31.995 23.04 33.06C23.805 33.405 24.645 33.585 25.5 33.585C28.815 33.585 31.5 30.9 31.5 27.585H28.5C28.5 29.235 27.15 30.585 25.5 30.585ZM11.46 4.54504L9.33 2.41504C6.345 5.40004 4.5 9.52504 4.5 14.085C4.5 18.645 6.345 22.77 9.33 25.755L11.445 23.64C9.015 21.195 7.5 17.82 7.5 14.085C7.5 10.35 9.015 6.97504 11.46 4.54504ZM17.25 14.085C17.25 16.155 18.93 17.835 21 17.835C23.07 17.835 24.75 16.155 24.75 14.085C24.75 12.015 23.07 10.335 21 10.335C18.93 10.335 17.25 12.015 17.25 14.085Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearing);
export default __webpack_public_path__ + "static/media/hearing.c59bf4938da0359a70efeb895becdd48.svg";
export { ForwardRef as ReactComponent };